module.exports = __webpack_public_path__ + "img/HU10241662.44dabe17.png";